module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0007#intro"
    }
  }, [_vm._v("Introduction: Polish Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0008#ch01"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("   Meet Me at the Fair: Poland’s Fourth Partition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0009#ch02"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("   Settling In: Creating Polonia’s Capital")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0010#ch03"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("   Living in Polish Chicago, 1880–1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0011#ch04"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("   World War One: A Turning Point")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0012#ch05"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("   Interwar Polonia: Years of Stress and Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0013#ch06"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("   Apocalypse Again: World War Two and Its Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0014#ch07"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("   The Lost Struggle: Chicago’s Polonia, Communist Poland, and a Changing City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0015#ch08"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("   A New Polonia")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0016#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0017#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chipacyga0018#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fbf832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-pacyga-0006.vue
// module id = 69
// module chunks = 0